<template>
	<div>
		<v-row class="mb-2">
			<v-col cols="12">
				<h1 class="headline mb-0">Nieuwe inhaalles</h1>
				<div class="caption text--secondary">
					Meld u aan voor een inhaalles. De coördinator van uw opleiding moet de aanmelding goedkeuren.
				</div>
			</v-col>
		</v-row>

		<v-alert
			v-if="errorMessage"
			type="error"
			border="right"
			colored-border
			elevation="2"
			class="mb-4"
		>{{ errorMessage }}</v-alert>

		<v-alert
			v-if="successMessage"
			type="success"
			border="right"
			colored-border
			elevation="2"
			class="mb-4"
		>{{ successMessage }}</v-alert>

		<v-card class="elevation-2">
			<v-card-text>
				<v-row>
					<v-col cols="12" md="6">
						<p class="font-weight-medium">Uw gegevens</p>
						<v-text-field
							dense
							:value="displayName"
							label="Student"
							filled
							readonly
						></v-text-field>
						<v-text-field
							dense
							:value="schoolyearName"
							label="Schooljaar"
							filled
							readonly
						></v-text-field>
						<v-text-field
							dense
							:value="studyName"
							label="Opleiding"
							filled
							readonly
						></v-text-field>
						<v-text-field
							dense
							:value="className"
							label="Eigen klas"
							filled
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" md="6">
						<p class="font-weight-medium">Inhaalles</p>
						<v-select
							dense
							:items="classes"
							item-text="name"
							item-value="id"
							v-model="form.class_overtake_id"
							filled
							label="Inhaal klas *"
						></v-select>
						<v-select
							dense
							:items="periodes"
							item-text="name"
							item-value="id"
							v-model="form.periode_id"
							filled
							label="Periode *"
						></v-select>
						<v-select
							dense
							:items="subjects"
							item-text="name"
							item-value="id"
							v-model="form.subject_id"
							filled
							label="Deelkwalificatie *"
						></v-select>
						<v-select
							dense
							:items="modules"
							item-text="module"
							item-value="id"
							v-model="form.module_id"
							filled
							label="Module *"
						></v-select>
						<v-textarea
							filled
							label="Motivatie"
							v-model="form.description"
							rows="3"
						></v-textarea>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-btn
					color="primary"
					depressed
					:loading="saving"
					:disabled="!canSubmit"
					@click="submit"
				>Aanmelden</v-btn>
				<v-btn text :to="{ path: '/main/inhaallessen' }">Annuleren</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../config";

const ax = Axios.create({
	baseURL: API_ROOT.osbod_salary,
	timeout: 60000
});

export default {
	name: "inhaalles-nieuw",
	data: function() {
		return {
			saving: false,
			errorMessage: null,
			successMessage: null,
			classes: [],
			periodes: [],
			subjects: [],
			modules: [],
			form: {
				class_overtake_id: null,
				periode_id: null,
				subject_id: null,
				module_id: null,
				description: ""
			}
		};
	},
	computed: {
		user() {
			return (
				this.$store.getters.getUser ||
				JSON.parse(localStorage.getItem("user") || "null")
			);
		},
		displayName() {
			if (!this.user) return "";
			if (this.user.display_name) return this.user.display_name;
			return [this.user.firstname, this.user.middlename, this.user.surname]
				.filter(Boolean)
				.join(" ");
		},
		studyId() {
			if (!this.user) return null;
			if (this.user.current_class && this.user.current_class.study_id) {
				return this.user.current_class.study_id;
			}
			return this.user.study_id || null;
		},
		studyName() {
			if (!this.user) return "—";
			if (this.user.current_class && this.user.current_class.tbl_sys_study) {
				return this.user.current_class.tbl_sys_study.name || "—";
			}
			return (this.user.tbl_sys_study && this.user.tbl_sys_study.name) || "—";
		},
		schoolyearName() {
			if (!this.user) return "—";
			if (this.user.current_class && this.user.current_class.tbl_sys_schoolyear) {
				return this.user.current_class.tbl_sys_schoolyear.name || "—";
			}
			return (
				(this.user.tbl_sys_schoolyear && this.user.tbl_sys_schoolyear.name) || "—"
			);
		},
		className() {
			if (
				!this.user ||
				!this.user.current_class ||
				!this.user.current_class.tbl_sys_class
			) {
				return "—";
			}
			return this.user.current_class.tbl_sys_class.name || "—";
		},
		canSubmit() {
			return !!(
				this.form.class_overtake_id &&
				this.form.periode_id &&
				this.form.subject_id &&
				this.form.module_id &&
				!this.saving
			);
		}
	},
	watch: {
		"form.class_overtake_id": function() {
			this.form.subject_id = null;
			this.form.module_id = null;
			this.subjects = [];
			this.modules = [];
			this.loadSubjects();
		},
		"form.periode_id": function() {
			this.form.subject_id = null;
			this.form.module_id = null;
			this.subjects = [];
			this.modules = [];
			this.loadSubjects();
		},
		"form.subject_id": function() {
			this.form.module_id = null;
			this.modules = [];
			this.loadModules();
		}
	},
	created() {
		this.loadClasses();
		this.loadPeriodes();
	},
	methods: {
		loadClasses() {
			var self = this;
			if (!this.studyId) return;
			ax.get("/school_class/selected_study/", {
				params: { study_id: this.studyId }
			}).then(function(response) {
				self.classes = response.data || [];
			});
		},
		loadPeriodes() {
			var self = this;
			ax.get("/periode/all").then(function(response) {
				self.periodes = response.data || [];
			});
		},
		loadSubjects() {
			var self = this;
			if (!this.form.class_overtake_id || !this.form.periode_id) return;
			ax.get("/subject/selected_class/", {
				params: {
					class_id: this.form.class_overtake_id,
					periode_id: this.form.periode_id
				}
			}).then(function(response) {
				self.subjects = response.data || [];
			});
		},
		loadModules() {
			var self = this;
			if (
				!this.form.class_overtake_id ||
				!this.form.periode_id ||
				!this.form.subject_id
			) {
				return;
			}
			ax.get("/teacher_subject_class/all_module/", {
				params: {
					class_id: this.form.class_overtake_id,
					periode_id: this.form.periode_id,
					subject_id: this.form.subject_id
				}
			}).then(function(response) {
				self.modules = response.data || [];
			});
		},
		async submit() {
			this.saving = true;
			this.errorMessage = null;
			this.successMessage = null;
			try {
				var result = await this.$store.dispatch(
					"createStudentOvertakeClass",
					this.form
				);
				this.successMessage =
					(result && result.msg) ||
					"Inhaalles aangemeld. Wacht op goedkeuring van de coördinator.";
				this.$router.push({ path: "/main/inhaallessen" });
			} catch (err) {
				this.errorMessage =
					(err && err.message) || "Aanmelden van inhaalles is mislukt.";
			} finally {
				this.saving = false;
			}
		}
	}
};
</script>
